import { Helmet } from "react-helmet-async";

import AboutHero from "../components/AboutHero";
import AboutSection from "../components/AboutSection";
import MissionVisionValues from "../components/MissionVisionValues";
import OurTeam from "../components/OurTeam";

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>
          About Us | TanBio BioMed Genomics Laboratory
        </title>

        <meta
          name="description"
          content="Learn about TanBio BioMed Genomics Laboratory, our mission, vision, experienced professionals and commitment to quality diagnostic services."
        />

        <link rel="canonical" href="https://tanbiomedlab.com/about" />
      </Helmet>

      <section id="about-hero">
        <AboutHero />
      </section>

      <section id="about">
        <AboutSection />
      </section>

      <section id="mission">
        <MissionVisionValues />
      </section>

      <section id="ourteam">
        <OurTeam />
      </section>
    </>
  );
}